import { ErrorBoundary } from '@wegic/ui';
import { Outlet } from 'react-router-dom';
import { usePageViewTracker } from '@/helpers/hooks';
import PageOops from '@/pages/PageOops';

/**
 * 根布局组件
 * 提供全局错误边界和通用布局结构
 */
export default function RootLayout() {
  usePageViewTracker();

  return (
    <ErrorBoundary fallback={(error, errorInfo) => <PageOops error={error} errorInfo={errorInfo} />}>
      <Outlet />
    </ErrorBoundary>
  );
}
